import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../CTTX_White_Logo_200px.png'; // Ensure the correct path


const Header = () => {
  return (
    <header className="navbar navbar-expand-lg navbar-dark bg-dark">
      <nav className="container-fluid">
        <Link className="navbar-brand" to="/"><img src={logo} alt="Cloud Team Realty" className="logo-img" /></Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link" to="/team">Leadership Team</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/agents">Our REALTORS®</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="https://cloudteamrealty.com/" target='_blank'>Find a Property</Link>
            </li>
            
            <li className="nav-item">
              <Link className="nav-link" to="/system">How we give back time</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/ticket-to-launch">Ticket To Launch</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/careers">Careers</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/getlicensed">Get Licensed</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;